export default "__VITE_ASSET__Bb7y5SDP__"